module.exports = __webpack_public_path__ + "static/img/constructor_256.3360228.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/constructor_256.png
// module id = h3TN
// module chunks = 0